// extracted by mini-css-extract-plugin
export var component = "CodeModule-module--component--fgJdP";
export var text = "CodeModule-module--text--+J-I3";
export var wrapper = "CodeModule-module--wrapper--NXqlT";